module.exports = __webpack_public_path__ + "static/SettleDownWebfont-b8b27cae85a8ebb6db77ac397368726e.woff";